const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var canUseDOM_default = canUseDOM;
export {
  canUseDOM,
  canUseDOM_default as default
};
//# sourceMappingURL=canUseDOM.js.map
